import HorizontalContentCard from './HorizontalContentCard';
export default HorizontalContentCard;
